import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/clusters';
import { selectors, DEFAULT_STATE } from '../reducers/clusters';
import api from '../apis/clusters';

const sagas = helper.createSagas('clusters', actionTypes, actions, api, selectors, DEFAULT_STATE);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [
    ...defaultSagas
];